import { brand } from '../global';
export const brandLine = {
    primary: brand[600],
};
//# sourceMappingURL=brand.js.map
